import moment from 'moment';

import BarChart from 'components/BarChart';
import AthleticAbility from 'pages/Report/ViewExam/ResultReport/AthleticAbility';

const NoResultReport = require('assets/resources/NoResultReport.svg').default;

const ResultReport = (props) => {
  const { analysisContent } = props;

  const checkFocusPower = () => {
    if (analysisContent?.analysis_results?.videos?.storytelling_scene?.focus_power) {
      return true;
    }
    return false;
  };

  const checkConversationPower = () => {
    if (analysisContent?.analysis_results?.videos?.storytelling_scene?.conversation_power) {
      return true;
    }
    return false;
  };

  const checkEmotion = () => {
    if (analysisContent?.analysis_results?.videos?.parent_communication?.emotion) {
      return true;
    }
    return false;
  };

  const checkLanguagePower = () => {
    if (analysisContent?.analysis_results?.videos?.parent_communication?.language_power) {
      return true;
    }
    return false;
  };

  return (
    <div className="w-full">
      {analysisContent && Object.keys(analysisContent)?.length > 0 && (
        <>
          <div className="flex items-center space-x-6 text-black/85 text-sm mb-8">
            <span>
              {'生成日'}：{moment().format('YYYY/MM/DD')}
            </span>
          </div>
          {analysisContent?.analysis_results?.age5 && analysisContent?.analysis_results?.age5?.length > 0 && (
            <div className="mt-8">
              <h1 className="text-xl font-bold text-black-102">5歳児健診項目</h1>
              <p className="text-sm text-secondary-354">各項目に対して「いいえ」と回答された件数が全体に占める割合を示すグラフです。</p>
              <div className="mt-2 py-6 px-8 border border-white-714/50 rounded-lg">
                <BarChart analysisContent={analysisContent?.analysis_results?.age5} />
              </div>
            </div>
          )}

          {analysisContent?.analysis_results?.videos?.motor_skills &&
            Object.keys(analysisContent?.analysis_results?.videos?.motor_skills).length > 0 && (
              <div className="mt-8">
                <h1 className="text-xl font-bold text-black-102">運動能力</h1>
                <div className="mt-2 py-6 px-8 border border-white-714/50 rounded-lg">
                  <AthleticAbility data={analysisContent} />
                </div>
              </div>
            )}

          {(checkFocusPower() || checkEmotion() || checkConversationPower() || checkLanguagePower()) && (
            <div className="mt-8">
              <h1 className="text-xl font-bold text-black-102">読み聞かせ10分のデータ分析</h1>
              <div className="mt-2 py-6 px-8 border border-white-714/50 rounded-lg">
                <div className="w-full grid grid-cols-2 gap-6">
                  {(checkFocusPower() || checkEmotion() || checkConversationPower()) && (
                    <div className="col-span-1">
                      {checkFocusPower() && (
                        <div className="w-full">
                          <h3 className="text-sm font-bold text-black-102">集中の様子</h3>
                          <p className="text-sm text-black-102 mt-2">
                            {analysisContent?.analysis_results?.videos?.storytelling_scene?.focus_power?.focused +
                              analysisContent?.analysis_results?.videos?.storytelling_scene?.focus_power?.not_focused}
                            分中
                            {analysisContent?.analysis_results?.videos?.storytelling_scene?.focus_power?.focused}分集中していました
                          </p>
                        </div>
                      )}
                      {checkConversationPower() && (
                        <div className="w-full mt-8">
                          <h3 className="text-sm font-bold text-black-102">会話の様子</h3>
                          <p className="text-sm text-black-102 mt-2">
                            返答あり：{analysisContent?.analysis_results?.videos?.storytelling_scene?.conversation_power?.responses}%
                          </p>
                          <p className="text-sm text-black-102 mt-2">
                            返答なし：{analysisContent?.analysis_results?.videos?.storytelling_scene?.conversation_power?.no_responses}%
                          </p>
                        </div>
                      )}
                      {checkEmotion() && (
                        <div className="w-full mt-8">
                          <h3 className="text-sm font-bold text-black-102">感情</h3>
                          <p className="text-sm text-black-102 mt-2">
                            笑顔・リラックス：{analysisContent?.analysis_results?.videos?.parent_communication?.emotion?.negative}%
                          </p>
                          <p className="text-sm text-black-102 mt-2">
                            ドキドキ・緊張：{analysisContent?.analysis_results?.videos?.parent_communication?.emotion?.positive}%
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                  {checkLanguagePower() && (
                    <div className="col-span-1">
                      <h3 className="text-sm font-bold text-black-102">語彙力</h3>
                      <p className="text-sm text-black-102 mt-2">
                        連体語：{analysisContent?.analysis_results?.videos?.parent_communication?.language_power?.link_words || 0}個
                      </p>
                      <p className="text-sm text-black-102 mt-2">
                        副詞：{analysisContent?.analysis_results?.videos?.parent_communication?.language_power?.adverbs || 0}個
                      </p>
                      <p className="text-sm text-black-102 mt-2">
                        形容詞：{analysisContent?.analysis_results?.videos?.parent_communication?.language_power?.adjectives || 0}個
                      </p>
                      <p className="text-sm text-black-102 mt-2">
                        動詞：{analysisContent?.analysis_results?.videos?.parent_communication?.language_power?.verb || 0}個
                      </p>
                      <p className="text-sm text-black-102 mt-2">
                        名詞：{analysisContent?.analysis_results?.videos?.parent_communication?.language_power?.noun || 0}個
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {(!analysisContent || Object.keys(analysisContent)?.length === 0) && (
        <div className="no-result-report bg-white w-full h-81.5 flex justify-center items-center">
          <img src={NoResultReport} alt="NoResultReport" />
        </div>
      )}
    </div>
  );
};

export default ResultReport;
